// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmModal .ant-modal-content {
  padding: 8px 8px 16px;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
}
.ConfirmModal .ant-modal-close {
  top: 8px;
  right: 8px;
}
.ConfirmModal .confirm-header {
  display: flex;
}
.ConfirmModal .confirm-header img {
  width: 16px;
  vertical-align: middle;
}
.ConfirmModal .confirm-header span {
  font-size: 12px;
  color: #333333;
  line-height: 14px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
}
.ConfirmModal .confirm-content {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 16px;
}
.ConfirmModal .confirm-content img {
  display: block;
  width: 24px;
  margin-right: 8px;
}
.ConfirmModal .confirm-content p {
  color: #333333;
  font-size: 14px;
}
.ConfirmModal .confirm-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 14px;
}
.ConfirmModal .confirm-footer > div {
  width: 88px;
  height: 32px;
  border-radius: 4px;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #00ce68;
  color: #00CE68;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/ConfirmModal/index.module.less"],"names":[],"mappings":"AAAA;EAGM,qBAAA;EACA,yBAAA;EACA,+CAAA;AADN;AAJA;EAQM,QAAA;EACA,UAAA;AADN;AARA;EAYM,aAAA;AADN;AAXA;EAcQ,WAAA;EACA,sBAAA;AAAR;AAfA;EAkBQ,eAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAAR;AAvBA;EA2BM,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AADN;AA7BA;EAgCQ,cAAA;EACA,WAAA;EACA,iBAAA;AAAR;AAlCA;EAqCQ,cAAA;EACA,eAAA;AAAR;AAtCA;EA0CM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AADN;AA5CA;EA+CQ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAAR","sourcesContent":[":global {\n  .ConfirmModal {\n    .ant-modal-content {\n      padding: 8px 8px 16px;\n      border: 1px solid #e7e7e7;\n      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);\n    }\n    .ant-modal-close {\n      top: 8px;\n      right: 8px;\n    }\n    .confirm-header {\n      display: flex;\n      img {\n        width: 16px;\n        vertical-align: middle;\n      }\n      span {\n        font-size: 12px;\n        color: #333333;\n        line-height: 14px;\n        display: inline-block;\n        vertical-align: middle;\n        margin-left: 4px;\n      }\n    }\n    .confirm-content {\n      display: flex;\n      align-items: center;\n      margin-top: 16px;\n      margin-left: 16px;\n      img {\n        display: block;\n        width: 24px;\n        margin-right: 8px;\n      }\n      p {\n        color: #333333;\n        font-size: 14px;\n      }\n    }\n    .confirm-footer {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      padding-right: 14px;\n      > div {\n        width: 88px;\n        height: 32px;\n        border-radius: 4px;\n        opacity: 1;\n        box-sizing: border-box;\n        border: 1px solid #00ce68;\n        color: #00CE68;\n        font-size: 14px;\n        text-align: center;\n        line-height: 32px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
